// option設定
var _option = document.querySelector('.option');
if (_option != null) {

let Parent = document.querySelector('.product__thumbs--scroller .menu');

    // タイトルの下にテキストを入れる場合に追加 -- 通常左揃え
    var _set = document.querySelector('.option .toptext');
    if (_set != null) {
        var _parent = document.querySelector('.feature-row__text');
        _parent.innerHTML += "<p class = " + "txt_l" + ">" + _set.innerHTML + "</p>";
    }

    // 中央揃え
    _set = document.querySelector('.option .toptext-c');
    if (_set != null) {
        var _parent =  document.querySelector('.feature-row__text');
        _parent.innerHTML += "<p class = " + "txt_c" + ">" + _set.innerHTML + "</p>";
    }

    // ページ読み込み時ページが2ページ目以降なら上段部分の表示を無効にする
    _set = document.querySelector('.option .f_onry');
    if (_set != null) {
        var _url = location.href;
        var _u = String(_url).slice(-1);
        var d_block = document.querySelector('.feature-row__description');
        if (!isNaN(Number(_u)) && Number(_u) != 1) {
          d_block.style.display = "none";
        } else {
          d_block.style.display = "initial";
        }
    }

    // クリックで開く目次を追加する
    _set = document.querySelector('.option .menu');
    if (_set != null) {
        var _wrap = document.createElement('div');
        var _menu = document.createElement('details');
        _menu.classList.add("pd-l_1rm");
        _wrap.setAttribute("id", "category");
      
        var _summary = document.createElement('summary');
        _summary.classList.add("f_bk", "f_13rm", "f_bld", "ls_01em", "mg-b_0", "details__summary");
        _summary.innerHTML = "Menu";
        _menu.appendChild(_summary);
      　
        //var _t2 = "<ul class=" + "mg-l_0" + ">";
        //var _t3 = "";
        var _t3data = document.querySelectorAll('.title');
        var _ul = document.createElement('ul');
        _ul.classList.add("mg-l_0");
      　
        for (var i = 0; i < _t3data.length; i ++) {
             var _id = _t3data[i].id;
             var _txt = _t3data[i].innerHTML;
             _txt.trim();
             
             var _li = document.createElement('li');
             _li.classList.add("pd-l_1rm", "pd-t_1rm");
             var _a = document.createElement('a');
             _a.classList.add("border-none", "f_gy");
             _a.setAttribute('href', "#" + _id);
             _a.innerHTML = "・"+_txt.trim();
             _li.appendChild(_a);
             _ul.appendChild(_li);
             //var _set = "<li class=pd-l_1rm>" + "<a href=#" + _id + " class=\"border-none f_bld\">・" + _txt + "</a></li>";
             //_t3 = _t3 + _set;
        }

        // 追加の項目を入れたい場合
        var _e = _set.children;
        if (_e.length > 0){
            for (var i = 0; i < _e.length; i ++) {
                 _e[i].classList.add("border-none", "f_gy");
                 var _li = document.createElement('li');
                 _li.classList.add("pd-l_1rm", "pd-t_1rm");
                 _li.appendChild(_e[i]);
                 _ul.appendChild(_li);
            }
        }

        //var _text = _t2 + _t3 + "</ul>"; 
        //_menu.innerHTML += _text;

        _menu.appendChild(_ul);
        _wrap.appendChild(_menu)

        //下の要素との間を開ける
        var _span = document.createElement('div');
        _span.classList.add("pd-b_3rm");
        _wrap.appendChild(_span);
        _option.before(_wrap);
    }
}

var _ranking = document.querySelector('li#target');
var _target = document.querySelector('li#change');

// -------------------- 以下はページ読み込み時一度だけ行われる処理
// ランキングに表示されるアイテムの表示名の文字数を制限する
// jquery使用
$(_ranking).insertBefore(_target);
var _counttextdata = document.querySelectorAll('.ranking_img p');
for (var i = 0; i < _counttextdata.length; i++) {
    var _str = _counttextdata[i].innerText;
    if (_str.length > 15){
        _str = 	_str.substr(0, 15) + "...";
        var _a = _str.substr(0, 8);
        var _b = _str.substr(8, 999);
        _str = _a + "\n" + _b;
    }
    
    _counttextdata[i].innerText = _str;
}

// ランキングの順位の画像を指定の場所に貼る
var _array = document.querySelectorAll('.ranking_img');
if (_array != null) {
  for (var l = 0; l < _array.length; l++) {
  
      // ランキングをiconで表示する場合
      _array[l].classList.add("w_initial");
      let _div = document.createElement('div');
      _div.classList.add("flex", "align-items_center", "jc-c");
    
      let _i = document.createElement('i');
      _i.classList.add("fas", "fa-crown", "f_bk", "f_13rm");
      _div.appendChild(_i);
    
      let _p = document.createElement('p');
      _p.classList.add("pd-l_1rm", "f_13rm");
      _p.innerHTML = (l + 1) + "位";
      _div.appendChild(_p);
    
      _array[l].insertBefore(_div, _array[l].children[0]);
      
  }
}

//ランキングのアイテムの値段を税込みに変更する
var _pricedata = document.querySelectorAll('.ranking_price');
for (var i = 0; i < _pricedata.length; i ++) {
    var _str = _pricedata[i].innerText;
    var _pos = _str.indexOf("円");
    var _set = _str.substr(0, _pos);
    var _checkpos = _str.indexOf(",");
  
    if (_checkpos != -1) {
        _set = _set.substr(0, _checkpos) + _set.substr(_checkpos + 1, 999);
    }
    _set = Math.round(Number(_set) * 1.1);

    _set = String(_set);
    var _length = _set.length;
    while(_length > 3) {

      var _a = _set.substr(0, _length - 3);
      var _b = ",";
      var _c = _set.substr(_length - 3, 999);

      _set = _a + _b + _c; 
      _length = _length - 3;
    }
  
    _set = _set + _str.substr(_pos, 999);
    _pricedata[i].innerText = _set;
}

// jquery
$(function () {
  $('.details__summary').click(function(){
	$('#category ul').toggleClass('active');
	$(this).toggleClass('active');
  });

  if (window.getSelection) {
      window.getSelection().removeAllRanges();
  }
});